<div class="slide-container yf-margin">
  <p class="title">{{'PHRASE.CHARGING_POINT_PHOTO'|translate}}</p>
  <div *ngIf="auth.isAuthenticated" class="icon-container">
    <ion-button class="btn square-big white" (click)="newPhotoToGallery()">
      <ion-icon slot="icon-only" color="secondary" name="cloud-upload-outline"></ion-icon>
    </ion-button>
  </div>
</div>
